const PREFIX = "/estimate/";
export const GET_BY_ID_URL = PREFIX + "get-by-id";
export const GET_HISTORY_URL = PREFIX + "history/get";
export const GET_SETTINGS_URL = PREFIX + "settings/get";
export const ADD_CATALOG_LABOR_TIME_URL = PREFIX + "items/add-catalog-labor-times";
export const ADD_CATALOG_REFERENCE_URL = PREFIX + "items/add-catalog-reference";
export const ADD_CATALOG_TIRE_URL = PREFIX + "items/add-catalog-tire";
export const ADD_CATALOG_LABOR_TIME_BY_CODE_URL = PREFIX + "items/add-labor-time-by-code";
export const ADD_ITEM_BY_NUMBER_URL = PREFIX + "items/add-item-by-number";
export const ADD_CUSTOM_ITEM_URL = PREFIX + "items/add-custom-item";
export const ADD_OPERATION_FROM_EASY_BASKET_URL = PREFIX + "items/add-operation-from-easy-basket";
export const ADD_BUNDLES_FROM_MY_STORE_URL = PREFIX + "items/add-bundles-from-my-store";
export const ADD_BUNDLES_FROM_AUTOCOMPLETE_URL = PREFIX + "items/add-bundles-from-autocomplete";
export const ADD_REFERENCE_FROM_AUTOCOMPLETE_URL = PREFIX + "items/add-reference-from-autocomplete";
export const ADD_REFERENCE_NUMBER_URL = PREFIX + "items/add-reference-number";
export const UPDATE_LABOR_TIME_URL = PREFIX + "items/update-labor-time";
export const UPDATE_OPERATION_LABOR_TIME_URL = PREFIX + "items/update-operation-labor-time";
export const UPDATE_REFERENCE_URL = PREFIX + "items/update-reference";
export const UPDATE_OPERATION_REFERENCE_URL = PREFIX + "items/update-operation-reference";
export const UPDATE_OPERATION_URL = PREFIX + "items/update-operation";
export const UPDATE_FREE_BUNDLE_OR_WASTE_RECYCLING_URL = PREFIX + "items/update-free-bundle";
export const REMOVE_ITEM_URL = PREFIX + "items/remove";
export const CLEAR_ITEMS_URL = PREFIX + "items/clear";
export const ADD_VEHICLE_URL = PREFIX + "vehicle/add";
export const ADD_DMS_ORDER_NUMBER_URL = PREFIX + "vehicle/add-dms-order-number";
export const UPDATE_VEHICLE_URL = PREFIX + "vehicle/update";
export const ADD_B2B_HISTORY_ESTIMATE_URL = PREFIX + "b2b/history/add-estimate";
export const UPDATE_COUNTER_PARTIES_URL = PREFIX + "b2b/counter-parties/update";
export const GET_REFERENCES_PRICE_URL = PREFIX + "b2b/prices/get";
export const GET_REFERENCES_STOCKS_URL = PREFIX + "b2b/stocks/get";
export const CHECKOUT_B2B_ESTIMATE_URL = PREFIX + "b2b/checkout";
export const UPDATE_CLIENT_URL = PREFIX + "client/update";
export const UPDATE_OBSERVATIONS_URL = PREFIX + "observations/update";
export const UPDATE_SETTINGS_URL = PREFIX + "settings/update";
export const ADD_CATALOG_REFERENCES_TO_BASKET_URL = PREFIX + "items/add-catalog-references-to-basket";
export const ESTIMATE_FROM_MAINTENANCE_PLAN = PREFIX + "from-maintenance-plan";
export const DELETE_ESTIMATE = PREFIX + "delete";
export const CANCEL_DELETION = PREFIX + "cancel-deletion";
export const QUERY_BUNDLES_AUTOCOMPLETE_URL = PREFIX + "bundles/autocomplete-search";
export const QUERY_REFERENCES_AUTOCOMPLETE_URL = PREFIX + "references/autocomplete-search";
